export default class TilesSequenceDto {
	public data = '';
}	